// Header height root variable override
const initHeaderHeight = () => {
  const header = document.querySelector('header-component');
  if (!header) return;

  const firstSection = document.querySelector('.main-content > div:first-child');
  if (!firstSection?.classList.contains('shopify-section') || !firstSection?.classList.contains('slideshow')) return;

  const observer = new ResizeObserver(entries => {
    for (const entry of entries) {
      document.documentElement.style.setProperty('--header-height', `${entry.contentRect.height}px`);
    }
  });

  observer.observe(header);
};
document.addEventListener('DOMContentLoaded', initHeaderHeight);


// Image wave svg overlay
const waveSvgImage = () => {
    const waveSections = document.querySelectorAll('.shopify-section:has(.wave-svg--image)');
    if(waveSections.length < 1) return;

    waveSections.forEach(waveSection => {
        const prevSibling = waveSection.previousElementSibling;
        if(!prevSibling) return;

        const prevSection = prevSibling.querySelector('section');
        if(!prevSection) return;

        const waveSvg = waveSection.querySelector('.wave-svg--image');

        const computedStyles = window.getComputedStyle(prevSection);
        const prevBgColor = computedStyles.getPropertyValue('--bg');

        waveSvg.style.setProperty('--section-bg', prevBgColor);
        
    })
}
document.addEventListener("DOMContentLoaded", waveSvgImage);
document.addEventListener('shopify:section:load', waveSvgImage);


// Home page nav overlay
const homePageNavOverlay = () => {
    const templateIndex = document.querySelector('.template-index');
    if (!templateIndex) return;

    const navOverlay = document.querySelector('.home-page-nav-overlay');
    if(!navOverlay) return;


    const siteHeader = document.querySelector('.site-header');
    const navOverlayBtn = document.querySelector('.btn--header-menu');
    const closeBtn = document.querySelector('.home-page-nav-overlay .icon-close');
    const announcementBar = document.querySelector('.announcement-bar-static');
    const bgOverlay = document.querySelector('.home-page-bg-overlay');

    let scrollY = 0;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    const getAnnouncementHeight = () => announcementBar ? announcementBar.offsetHeight : 0;

    const setOverlayTop = () => {
        navOverlay.style.top = `${-getAnnouncementHeight()}px`;
    }

    const lockScroll = () => {
        document.body.style.overflow = 'hidden';
        if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    const unlockScroll = () => {
        document.body.style.overflow = '';
        if (scrollbarWidth > 0) document.body.style.paddingRight = '';
    }

    const openNav = () => {
        scrollY = window.scrollY;
        const announcementHeight = getAnnouncementHeight();
        const top = announcementBar
            ? scrollY <= announcementHeight
                ? -(announcementHeight - scrollY)
                : scrollY - announcementHeight
            : scrollY;

        navOverlay.style.top = `${top}px`;
        lockScroll();
        siteHeader.classList.add('nav-overlay-open');
        navOverlay.classList.add('is-open');
        bgOverlay.classList.add('is-open');
    }

    const closeNav = () => {
        navOverlay.classList.remove('is-open');
        bgOverlay.classList.remove('is-open');
        unlockScroll();
        setOverlayTop();
        navOverlay.addEventListener('transitionend', (e) => {
            if (e.propertyName !== 'transform') return;
            siteHeader.classList.remove('nav-overlay-open');
        }, { once: true });
    }

    const resizeObserver = new ResizeObserver(setOverlayTop);
    if (announcementBar) {
        resizeObserver.observe(announcementBar);
    } else {
        window.addEventListener('resize', setOverlayTop);
    }

    const headerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class' &&
                siteHeader.classList.contains('site-header--compress') &&
                navOverlay.classList.contains('is-open')) {
                closeNav();
            }
        });
    });
    headerObserver.observe(siteHeader, { attributes: true });

    setOverlayTop();
    navOverlayBtn.addEventListener('click', openNav);
    closeBtn.addEventListener('click', closeNav);
    bgOverlay?.addEventListener('click', closeNav);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && navOverlay.classList.contains('is-open')) closeNav();
    });
}

document.addEventListener("DOMContentLoaded", homePageNavOverlay);
document.addEventListener('shopify:section:load', homePageNavOverlay);


// Flavor scale animation
const flavorScale = () => {
  const flavorScales = document.querySelectorAll('.flavor-scale');

  flavorScales.forEach(scale => {
    const ratingClass = [...scale.classList].find(c => c.startsWith('flavor-scale-rating--'));
    if (!ratingClass) return;

    const targetRating = parseInt(ratingClass.replace('flavor-scale-rating--', ''));
    const targetPercent = targetRating * 10;

    const bar = scale.querySelector('.flavor-scale--bar');
    const img = scale.querySelector('.flavor-scale--bar img');

    bar.style.setProperty('--bar-width', '0%');
    img.style.left = '0%';

    const setPosition = (percent) => {
      img.style.left = `${percent}%`;
      bar.style.setProperty('--bar-width', `${percent}%`);
    };

    const animateTo = (from, to, duration, onComplete) => {
      const start = performance.now();
      const tick = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        setPosition(from + (to - from) * eased);

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          onComplete?.();
        }
      };
      requestAnimationFrame(tick);
    };

    const runAnimation = () => {
      scale.classList.remove(ratingClass);
      animateTo(0, 100, 800, () => {
        setTimeout(() => {
          animateTo(100, targetPercent, 600, () => {
            // img.style.left = '';
            scale.classList.add(ratingClass);
          });
        }, 150);
      });
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(runAnimation, 1000);
          observer.unobserve(scale);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(scale);
  });
};
document.addEventListener("DOMContentLoaded", flavorScale);
document.addEventListener('shopify:section:load', flavorScale);


// Flickity height adjuster
function setHeight() {
  const parents = document.querySelectorAll('.height-adjuster-ctr');
  parents.forEach(parent => {
    const prodGridInfos = parent.querySelectorAll('.height-adjuster__item');
    let maxHeight = 0;

    prodGridInfos.forEach(item => {
      item.style.height = 'auto';
      const itemHeight = item.offsetHeight;
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });

    prodGridInfos.forEach(item => {
      item.style.height = `${maxHeight}px`;
    });
  });
}

function checkAndSetHeight() {
  const prodGridInfos = document.querySelectorAll('.height-adjuster-ctr .height-adjuster__item');

  if (window.innerWidth > 768) {
    setHeight();
  } else {
    prodGridInfos.forEach(item => {
      item.style.height = 'auto';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.height-adjuster-ctr')) return;

  checkAndSetHeight();

  const resizeObserver = new ResizeObserver(() => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkAndSetHeight, 150);
  });

  let resizeTimer;
  document.querySelectorAll('.height-adjuster-ctr').forEach(el => {
    resizeObserver.observe(el);
  });

  document.addEventListener('shopify:section:load', checkAndSetHeight);
});


// Template title reverse wrap
const adjustTitleWrap = (title, threshold = 0) => {
  if (!title) return;

  if (!title.dataset.originalText) {
    title.dataset.originalText = title.innerText.trim();
  }

  const words = title.dataset.originalText.split(' ');
  title.innerHTML = words.map(word => `<span>${word}&nbsp;</span>`).join('');

  const titleWidth = title.offsetWidth;
  const lines = [];
  let remaining = [...words];

  while (remaining.length > 0) {
    let lineWords = [...remaining];
    
    while (lineWords.length > 0) {
      title.innerHTML = lineWords.map(word => `<span>${word}&nbsp;</span>`).join('');
      const spans = Array.from(title.querySelectorAll('span'));
      const totalWidth = spans.reduce((acc, span) => acc + span.offsetWidth, 0);
      
      if (totalWidth <= titleWidth + threshold) break;
      lineWords = lineWords.slice(1);
    }

    lines.unshift(lineWords.join(' '));
    remaining = remaining.slice(0, remaining.length - lineWords.length);
  }

  title.innerHTML = lines.join('<br>');
};

const runAll = () => {
  document.querySelectorAll('.section-header--article h1').forEach(title => adjustTitleWrap(title, 2));
  document.querySelectorAll('.section--template-title .text__heading').forEach(title => adjustTitleWrap(title, 4));
};

// document.addEventListener('DOMContentLoaded', runAll);
// document.addEventListener('shopify:section:load', runAll);
// window.addEventListener('resize', runAll);